<template>
  <div class = 'container' id = 'main_display' style = 'width: 100%'>
    <div v-show="!isLoading" class = 'container-fluid' style = 'height: 100%; position: relative;'>
      <h4 style="text-align: center; font-size: 18px;">任務數據
        <span v-if="no_of_total_activities.length === 0" style="color: green">(暫無任務)</span>
        <span v-else style="color: green">(共有 {{ no_of_total_activities }} 個任務)</span>
      </h4>
      <div style = 'padding: 30px 0;'>
        <ReportCell v-for="week in weeks" :key="week.id" :week_id="week.id" :week_title="week.title" :activities="week.activities" :deadline="week.end_datetime"/>
      </div>
    </div>
    <Loading v-show="isLoading"></Loading>
  </div>
</template>
<script>
import ReportCell from '@/components/Report/ReportCell.vue'
import Loading from '@/components/Utility/Loading.vue'
var moment = require('moment')
let format = 'YYYY-MM-DD HH:mm:ss'
export default {
  data () {
    return {
      isLoading: true,
      course_id: parseInt(this.$route.query.course),
      no_of_total_activities: '',
      weeks: []
    }
  },
  components: {
    Loading,
    ReportCell
  },
  async created () {
    await this.$store.dispatch('request', {
      route: 'courses/' + this.course_id + '/report'
    }).then(r => {
      console.log(r)
      this.no_of_total_activities = r.week_activity_count
      this.weeks = r.weeks
      this.weeks.sort((a, b) => {
        return moment(a.end_datetime, format).isBefore(moment(b.end_datetime, format)) ? 1 : -1
      })
      console.log(this.weeks.map(w => w.end_datetime))
    })
    this.isLoading = false
  },
  methods: {
  }
}
</script>
